import Axios from "axios";
import { cmc3_api_gateway } from "../config/config"
import { loading } from "../helpers/default";
import { error_handle } from "../helpers/error";


class ModelBusdVn30{
    constructor(){
        this.url = cmc3_api_gateway
    }

    getBusdVn30(startTime , stopTime , aloading=false){
        loading(true, 'Loading...')
        return Axios.request({
            url: this.url + '/busd_vn30/read',
            method: "POST",
            data: {
                startTime : startTime,
                stopTime : stopTime,
            },
            withCredentials: true, 
        })

            .then(response => {
                loading(false, 'Loading...')
                response = response['data'];
                if(response['result']) return response
                error_handle(response)

            })
            .catch(error => {
                error_handle(error)
            })
    }

    


}


export default ModelBusdVn30